import FormPropertyInformation from './FormPropertyInformation';

export default FormPropertyInformation;
